import { useState } from "react";
import { toast } from "sonner";
import { CalendarClock } from "lucide-react";
import { PayRailButtons } from "../payments/PayRailButtons";

const GOLD = "#C9A84C";
const SERIF = { fontFamily: "'Cormorant Garamond','Playfair Display',Georgia,serif" };
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export function RenewBar({ me, api }) {
  const [busy, setBusy] = useState(false);
  const ent = me.account.entitlement;
  if (!ent.subscription_active || ent.subscription_days_left > 30) return null;
  const urgent = ent.subscription_days_left <= 7;
  const pay = async (railChoice) => {
    setBusy(railChoice);
    try { const r = await api.post("/billdesk/pay/start", { plan: "subscription", payment_rail: railChoice }); window.location.href = `${r.data.pay_url}?rail=${railChoice}`; }
    catch (e) { toast.error(e.response?.data?.detail || "Could not start renewal"); setBusy(false); }
  };
  return (
    <div data-testid="billdesk-renew-bar" className="mt-6 border p-4 grid md:grid-cols-[1fr_300px] gap-4 items-center" style={{ borderColor: urgent ? "#E0707080" : `${GOLD}66`, background: urgent ? "#1a0c0c" : "#0f0d08" }}>
      <div className="flex items-start gap-3">
        <CalendarClock size={18} style={{ color: urgent ? "#E07070" : GOLD }} className="mt-1 shrink-0" />
        <div>
          <div className="text-xl" style={SERIF} data-testid="billdesk-renew-title">Annual subscription {ent.subscription_days_left === 0 ? "expires today" : `expires in ${ent.subscription_days_left} day${ent.subscription_days_left === 1 ? "" : "s"}`} · {fmt(me.account.subscription_until)}</div>
          <div className="font-body text-sm text-[#C9C3B4] mt-1">Renew now and the new 12-month term is added to the end of your current one — no days lost. ₹9,999 + 18% GST.</div>
        </div>
      </div>
      <PayRailButtons testId="renew-subscription" compact amountLabel="₹11,798.82" busy={busy} onPay={pay} />
    </div>
  );
}
